import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { usePreferredReducedMotion, useScroll, useWindowSize } from "@vueuse/core";
import { computed } from "vue";
// Components
import SvgIcon from "@/common/components/SvgIcon.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'BackToTopButton',
    setup(__props) {
        const { y } = useScroll(window);
        const { height } = useWindowSize();
        const prefersReducedMotion = usePreferredReducedMotion();
        // Reveal once the reader has scrolled past a full viewport of content.
        const isVisible = computed(() => y.value >= height.value);
        const scrollToTop = ({ currentTarget }) => {
            window.scrollTo({ top: 0, behavior: prefersReducedMotion.value === "reduce" ? "auto" : "smooth" });
            // Drop focus off the button so keyboard users resume tabbing from the top of the page.
            if (currentTarget instanceof HTMLElement)
                currentTarget.blur();
        };
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "back-to-top",
                    onClick: scrollToTop
                }, [
                    _createVNode(SvgIcon, {
                        icon: "icon-arrow-up-small-3",
                        width: "0.625rem",
                        height: "0.625rem"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Back to top")), 1)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
